// Tokens de plantilla · motor.md §4. ÚNICA fuente de cifras: catalogo.json.
// Si un token no resuelve, no se inventa: se muestra ND.
// overrides: edición en vivo (AC12) · solo en memoria, nunca toca el archivo.
export const fmtCOP = (n) => '$' + Number(n).toLocaleString('es-CO');

export function createResolver(catalogo, overrides = {}) {
  const byId = {};
  for (const p of catalogo.productos) byId[p.id] = p;

  const row = (id) => {
    const base = byId[id];
    if (!base) return null;
    const ov = overrides[id];
    return ov ? { ...base, ...ov, prima_origen: 'editada en vivo · AC12' } : base;
  };

  const origen = (id) => {
    const p = row(id);
    return p ? p.prima_origen || 'ND' : 'ND';
  };

  const prima = (id) => {
    const p = row(id);
    if (!p || p.prima_min == null) return 'ND (sin tarifa pública)';
    const origen = p.prima_origen === 'rango del ramo' ? 'rango típico del mercado' : p.prima_origen || 'ND';
    if (p.prima_min === p.prima_max) return `${fmtCOP(p.prima_min)}/mes (${origen})`;
    return `${fmtCOP(p.prima_min)}\u2013${fmtCOP(p.prima_max)}/mes (${origen})`;
  };

  const primaCorta = (id) => {
    const p = row(id);
    return p && p.prima_min != null ? fmtCOP(p.prima_min) : 'ND';
  };

  const ded = (id) => {
    const p = row(id);
    return p && p.deducible ? p.deducible.split(';')[0].trim().replace(/(^|[^\d$.,])(\d{4,})(?![\d.,])/g, (m, pre, n) => `${pre}${fmtCOP(Number(n))}`) : 'ND';
  };

  const nombre = (id) => (byId[id] ? byId[id].producto : 'ND');

  const rango = (categoria) => {
    const rows = catalogo.productos.filter(
      (p) => p.categoria === categoria && p.prima_origen === 'rango del ramo' && p.prima_min != null,
    );
    if (!rows.length) return 'ND';
    const min = Math.min(...rows.map((p) => p.prima_min));
    const max = Math.max(...rows.map((p) => p.prima_max));
    return `${fmtCOP(min)}\u2013${fmtCOP(max)}/mes (rango típico del mercado)`;
  };

  const tpl = (s) => {
    if (typeof s !== 'string') return s;
    // Un solo pase, sin reintentos: token mal formado o sin dato → 'ND'. Jamás un bucle.
    if (!s.includes('{{')) return s;
    try {
      return s.replace(/\{\{(prima|primaCorta|ded|rango|nombre):([^}]*)\}\}/g, (m, fn, arg) => {
        try {
          const f = { prima, primaCorta, ded, rango, nombre }[fn];
          const out = f ? f(String(arg || '').trim()) : null;
          return out == null || out === '' ? 'ND' : out;
        } catch (e) {
          return 'ND';
        }
      });
    } catch (e) {
      return 'ND';
    }
  };

  return { byId, prima, primaCorta, ded, nombre, rango, tpl, origen };
}
